import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton } from '@lili/lili-frontend-common';
import { UserMessage } from '../../DesignSystem/LiliUserMessage/UserMessage';
import { ReactComponent as CloseIcon } from '../../assets/svg/invoices-icons/icon-x-exit.svg';
import { ReactComponent as OopsIcon } from '../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';

interface IErrorModalProps {
  onClose: () => void,
  customTitle?: string,
  text?: string,
  buttonText?: string,
  onButtonClick: () => void;
}

export const ErrorModal = ({
  onClose,
  text,
  buttonText,
  onButtonClick,
  customTitle,
}: IErrorModalProps) => {
  const { t } = useTranslation();
  const mainWrapperOverrideClassName =
    'bg-bw07 flex fixed inset-0 h-screen w-screen bg-opacity-70 z-50 items-center justify-center';
  const contentWrapperOverrideClassName = 'w-[400px] h-[504px] rounded-xl bg-bw00/[.95] px-[24px] pt-[34px] pb-[40px] ';

  return (
    <UserMessage
      id='error-modal'
      mainWrapperOverrideClassName={mainWrapperOverrideClassName}
      contentWrapperOverrideClassName={contentWrapperOverrideClassName}
      onClick={onClose}
    >
      <CloseIcon className='absolute left-3 top-3' onClick={onClose} />
      <div className='flex justify-between flex-col h-full'>
        <div>
          <OopsIcon className='m-auto mt-[47px] mb-[60px]' />
          <div id='errorModalTitle' className='font-metricRMedium text-lg text-bw08 text-center leading-7 mb-[8px]'>{customTitle || t('ERROR_MODAL.TITLE')}</div>
          <div id='errorModalBody' className='font-metricR text-md text-bw07 text-center leading-6'>{text || t('ERROR_MODAL.DEFAULT_ERROR_TEXT')}</div>
        </div>
        <LiliButton
          id='errorModalCta'
          title={buttonText || t('ERROR_MODAL.DEFAULT_BTN_TEXT')}
          className='w-[158px] h-[54px] mx-auto'
          onClick={onButtonClick}
        />
      </div>
    </UserMessage>
  );
};
